<template>
  <div>
    <div class="airlines-pricelist-tnc" v-if="!isModalLoading">
      <h1 class="subhead">Terms & Condition</h1>
      <ul v-if="terms.length">
        <li class="subhead" v-for="(term, index) in terms" :key="index">{{term}}</li>
      </ul>
      <div v-else>-</div>
    </div>
    <a-loading v-else/>
  </div>
</template>

<script>
import api from '@/api'
import { restEdge } from "@/api/edgeUrls"

import { ALoadingPrimary } from "ui-kit-v1"

export default {
  name: 'adx-airport-placement-tnc',
  components: {
    'a-loading': ALoadingPrimary,
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      terms: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isModalLoading = true
      const { data, status } = await api.get(restEdge.airlinesPlacement(this.placementId), { needToken: true, useRestEdge: true })

      if (status === 200) {
        this.terms = data.airlinesMedia.termsCondition.map(term => term)
      }

      this.isModalLoading = false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>